export const GridTextAlign = "left"
export const GridNumberAlign = "right"
export const GridDateAlign = "center"
export const GridFontFamily = "Gt-Walsheim-medium"
export const GridFontSize = "13px"
export const GridFontWeight = "bold"

export const GridHeaderStyle = {
    fontFamily: "Gt-Walsheim-medium",
    fontSize: "14px",
    fontWeight: "bold",
    verticalAlign: "text-top",
}
export const GridColumnsStyle = (cell, row, rowIndex, colIndex) => {
    const fontFamily = "Gt-Walsheim-medium";
    const fontSize = "12px";
    const fontWeight = "normal";
    const textAlign = "left";
    return { fontFamily, fontSize, fontWeight, textAlign };
}
export const GridColumnsStyleStatus = (cell, row, rowIndex, colIndex) => {
    const fontFamily = "Gt-Walsheim-medium";
    const fontSize = "12px";
    const fontWeight = "normal";
    const textAlign = "left";
    const display="contents"
    return { fontFamily, fontSize, fontWeight, textAlign,display };
}
export const GridColumnsDateStyle = (cell, row, rowIndex, colIndex) => {
    const fontFamily = "Gt-Walsheim-medium";
    const fontSize = "12px";
    const fontWeight = "normal";
    const textAlign = "Center";
    return { fontFamily, fontSize, fontWeight, textAlign };
}
export const GridColumnsNumberStyle = (cell, row, rowIndex, colIndex) => {
    const fontFamily = "Gt-Walsheim-medium";
    const fontSize = "12px";
    const fontWeight = "normal";
    const textAlign = "right";
    return { fontFamily, fontSize, fontWeight, textAlign };
}
export const GridColumnsActionStyle = (cell, row, rowIndex, colIndex) => {
    const fontFamily = "Gt-Walsheim-medium";
    const fontSize = "12px";
    const fontWeight = "normal";
    const textAlign = "Center";
    const minWidth="149px";
    return { fontFamily, fontSize, fontWeight, textAlign,minWidth };
}

